export default "__VITE_ASSET__ebLatTLS__"